import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TakePictureComponent} from './take-picture/take-picture.component';
import {TranslateModule} from '@ngx-translate/core';
import {AssessmentResultComponent} from './assessment-result/assessment-result.component';
import {AssessmentTextLinkComponent} from './assessment-text-link/assessment-text-link.component';
import {TextWithLinkComponent} from './atomic/text-with-link/text-with-link.component';
import {AssessmentTextDescComponent} from './assessment-text-desc/assessment-text-desc.component';


@NgModule({
  declarations: [
    TakePictureComponent,
    AssessmentResultComponent,
    TextWithLinkComponent,
    AssessmentTextLinkComponent,
    AssessmentTextDescComponent
  ],
  exports: [
    TakePictureComponent,
    AssessmentResultComponent,
    TextWithLinkComponent,
    AssessmentTextLinkComponent,
    AssessmentTextDescComponent
  ],
  imports: [
    CommonModule,
    TranslateModule
  ]
})
export class SharedModule {
}
